import { createRouter, createWebHistory } from 'vue-router'
import { getRandomDomain, generateRandomString } from '@/utils/randomGenerator'

// 检查当前域名是否在允许列表中
const checkDomain = () => {
  const allowedDomains = [
    'vip1.4455kk.xyz',
    'vip2.4455kk.xyz',
    'vip3.4455kk.xyz',
    'vip4.4455kk.xyz',
    'vip5.4455kk.xyz',
    'vip6.4455kk.xyz',
    'vip7.4455kk.xyz',
    'localhost', 
    '127.0.0.1'
  ];
  
  const currentDomain = window.location.hostname;
  return allowedDomains.includes(currentDomain);
};

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/HomePage.vue')
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('@/views/SearchPage.vue')
  },
  {
    path: '/meitui',
    name: 'Meitui',
    component: () => import('@/views/CategoryPage.vue'),
    props: { category: '美腿丝袜', jsonFile: '/all_美腿丝袜.json' }
  },
  {
    path: '/xiuren',
    name: 'Xiuren',
    component: () => import('@/views/CategoryPage.vue'),
    props: { category: '秀人合集', jsonFile: '/all_秀人合集.json' }
  },
  {
    path: '/cos',
    name: 'Cosplay',
    component: () => import('@/views/CategoryPage.vue'),
    props: { category: 'Cosplay', jsonFile: '/all_cosplay.json' }
  },
  {
    path: '/wanghon',
    name: 'Wanghong',
    component: () => import('@/views/CategoryPage.vue'),
    props: { category: '网红精选', jsonFile: '/all_网红精选.json' }
  },
  {
    path: '/mingzhan',
    name: 'Mingzhan',
    component: () => import('@/views/CategoryPage.vue'),
    props: { category: '名站套图', jsonFile: '/all_名站套图.json' }
  },
  {
    path: '/album/:id',
    name: 'Album',
    component: () => import('@/views/AlbumDetail.vue'),
    props: true
  },
  // 视频分类路由
  {
    path: '/video/3d',
    name: 'Video3D',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: '3d' }
  },
  {
    path: '/video/91',
    name: 'Video91',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: '91' }
  },
  {
    path: '/video/anime',
    name: 'VideoAnime',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'anime' }
  },
  {
    path: '/video/huangjia',
    name: 'VideoHuangjia',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'huangjia' }
  },
  {
    path: '/video/madou',
    name: 'VideoMadou',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'madou' }
  },
  {
    path: '/video/mitao',
    name: 'VideoMitao',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'mitao' }
  },
  {
    path: '/video/oumei',
    name: 'VideoOumei',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'oumei' }
  },
  {
    path: '/video/tangxin',
    name: 'VideoTangxin',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'tangxin' }
  },
  {
    path: '/video/tianmei',
    name: 'VideoTianmei',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'tianmei' }
  },
  {
    path: '/video/tuzi',
    name: 'VideoTuzi',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'tuzi' }
  },
  {
    path: '/video/xiangjiao',
    name: 'VideoXiangjiao',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'xiangjiao' }
  },
  {
    path: '/video/xingkong',
    name: 'VideoXingkong',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'xingkong' }
  },
  {
    path: '/video/hd',
    name: 'VideoHD',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'hd' }
  },
  {
    path: '/video/madonna',
    name: 'VideoMadonna',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'madonna' }
  },
  {
    path: '/video/modd',
    name: 'VideoModd',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 'modd' }
  },
  {
    path: '/video/s1',
    name: 'VideoS1',
    component: () => import('@/views/VideoCategoryPage.vue'),
    props: { category: 's1' }
  },
  {
    path: '/video/player/:id',
    name: 'VideoPlayer',
    component: () => import('@/views/VideoPlayerPage.vue'),
    props: true
  },
  {
    // 随机路由（匹配任何随机路径）
    path: '/:pathMatch(.*)*',
    name: 'Random',
    component: () => import('@/views/HomePage.vue')
  },
  {
    path: '/TgGallery',
    name: 'TgGallery',
    component: () => import('@/views/TgGallery.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// 全局路由前置守卫
router.beforeEach((to, from, next) => {
  // 记录路由跳转
  console.log(`路由从 ${from.fullPath} 跳转到 ${to.fullPath}`);
  
  // 如果域名不合法且不是本地开发环境，重定向到随机域名
  if (!checkDomain() && !['localhost', '127.0.0.1'].includes(window.location.hostname)) {
    const domain = getRandomDomain();
    const path = generateRandomString(25);
    window.location.href = `https://${domain}/${path}`;
  } else {
    next();
  }
})

export default router 